<!-- components/FooterSection.vue -->
<template>
    <footer class="bg-white text-primary py-12">
      <div class="container mx-auto px-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          <!-- Logo and Brief Description -->
          <div class="col-span-1 md:col-span-2 lg:col-span-1">
            <img src="/logo.png" alt="Colonie Des Rêves Logo" class="h-12 mb-4">
            <p class="text-sm mb-4">Colonie Des Rêves provides memorable experiences for children, combining adventure, learning, and fun in a safe and stimulating environment.</p>
            <div class="flex space-x-4">
              <a href="https://www.facebook.com/coloniedesreves" target="_blank" rel="noopener noreferrer" class="text-primary hover:text-primary transition-colors">
                <Facebook class="w-6 h-6" />
              </a>
              <a href="https://www.instagram.com/coloniedesreves" target="_blank" rel="noopener noreferrer" class="text-primary hover:text-primary transition-colors">
                <Instagram class="w-6 h-6" />
              </a>
              <a href="https://www.tiktok.com/@coloniedesreves" target="_blank" rel="noopener noreferrer" class="text-primary transition-colors">
                <svg class="w-6 h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-linejoin="round">
                  <path d="M16.8217 5.1344C16.0886 4.29394 15.6479 3.19805 15.6479 2H14.7293M16.8217 5.1344C17.4898 5.90063 18.3944 6.45788 19.4245 6.67608C19.7446 6.74574 20.0786 6.78293 20.4266 6.78293V10.2191C18.645 10.2191 16.9932 9.64801 15.6477 8.68211V15.6707C15.6477 19.1627 12.8082 22 9.32386 22C7.50043 22 5.85334 21.2198 4.69806 19.98C3.64486 18.847 2.99994 17.3331 2.99994 15.6707C2.99994 12.2298 5.75592 9.42509 9.17073 9.35079M16.8217 5.1344C16.8039 5.12276 16.7861 5.11101 16.7684 5.09914M6.9855 17.3517C6.64217 16.8781 6.43802 16.2977 6.43802 15.6661C6.43802 14.0734 7.73249 12.7778 9.32394 12.7778C9.62087 12.7778 9.9085 12.8288 10.1776 12.9124V9.40192C9.89921 9.36473 9.61622 9.34149 9.32394 9.34149C9.27287 9.34149 8.86177 9.36884 8.81073 9.36884M14.7244 2H12.2097L12.2051 15.7775C12.1494 17.3192 10.8781 18.5591 9.32386 18.5591C8.35878 18.5591 7.50971 18.0808 6.98079 17.3564"/>
                </svg>
              </a>
            </div>
          </div>
  
          <!-- Quick Links -->
          <div>
            <h3 class="text-lg font-semibold mb-4 text-primary">Quick Links</h3>
            <ul class="space-y-2">
              <li><a href="#" class="hover:text-primary transition-colors">Home</a></li>
              <li><a href="/careers" class="hover:text-primary transition-colors">Careers</a></li>
              <li><a href="/#branches" class="hover:text-primary transition-colors">Branches</a></li>
              <li><a href="/registration" class="hover:text-primary transition-colors">Register</a></li>
              <li><a href="#contact" class="hover:text-primary transition-colors">Contact</a></li>
            </ul>
          </div>
  
          <!-- Contact Information -->
          <div>
            <h3 class="text-lg font-semibold mb-4 text-primary">Contact</h3>
            <ul class="space-y-2">
              <li class="flex items-center">
                <Phone class="w-5 h-5 mr-2 text-primary" />
                <a href="tel:+96170498999" class="hover:text-[#009FE3] transition-colors">+961 70 498 999</a>
              </li>
              <li class="flex items-center">
                <Mail class="w-5 h-5 mr-2 text-primary" />
                <a href="mailto:coloniedesreves@hnoudproduction.com" class="hover:text-[#009FE3] transition-colors">coloniedesreves@hnoudproduction.com</a>
              </li>
            </ul>
          </div>
  
          <!-- Newsletter Signup -->
          <div>
            <h3 class="text-lg font-semibold mb-4 text-primary">Stay Informed</h3>
            <p class="text-sm mb-4">Sign up for our newsletter to receive the latest news and special offers.</p>
            <form @submit.prevent="subscribeNewsletter" class="flex border border-primary rounded-md w-fit">
              <input 
                type="email" 
                v-model="email" 
                placeholder="Your email" 
                class="flex-grow px-4 py-2 rounded-l-md text-[#1D1D1B]"
                required
              >
              <button 
                type="submit" 
                class="bg-primary hover:bg-primary/80 px-4 py-2 rounded-r-md text-white transition-colors"
              >
                Subscribe
              </button>
            </form>
          </div>
        </div>
  
        <!-- Copyright -->
        <div class="mt-8 pt-8 border-t border-gray-700 text-center">
          <p>&copy; {{ new Date().getFullYear() }} Colonie Des Rêves. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </template>
  
  <script lang="ts">
  import { ref } from 'vue'
  import { Facebook, Instagram, Phone, Mail } from 'lucide-vue-next'
  
  export default {
    name: 'FooterSection',
    components: {
      Facebook,
      Instagram,
      Phone,
      Mail,
    },
    setup() {
      const email = ref('')
  
      const subscribeNewsletter = () => {
        // Implement newsletter subscription logic here
        console.log('Subscribing email:', email.value)
        // Reset email input after submission
        email.value = ''
      }
  
      return {
        email,
        subscribeNewsletter
      }
    }
  }
  </script>

  <style scoped>
  .footer {
    padding: 1rem;
    background-color: #f8f9fa;
    margin-top: auto;
  }
  
  .footer-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .footer-links {
    display: flex;
    gap: 1rem;
  }
  
  .footer-links a {
    text-decoration: none;
    color: #333;
  }
  </style>